import { useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'sonner';
import { createRunSendRecovery } from '@/utils/runSendRecovery';
import { markReviewQueueDirty } from '@/utils/reviewQueueEvents';

export function useRunSendRecovery({ session, onSettled }) {
  const callback = useRef(onSettled); callback.current = onSettled;
  const [state, setState] = useState({ items: [], busy: new Set(), messages: new Map(), loading: false, error: '', nextCursor: null });
  const owner = useMemo(() => createRunSendRecovery(session, {
    changed: setState,
    settled: value => {
      markReviewQueueDirty('review_queue_changed');
      callback.current?.(value);
    },
    // A new authenticated opening must reacquire local ownership, never reuse a token.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [session.key]);
  useEffect(() => {
    owner.activate(); setState(owner.snapshot()); void owner.load();
    return () => owner.retire();
  }, [owner]);
  return { ...state, owner, load: more => owner.load(more),
    async send(context, request) {
      const result = await owner.start(context, request);
      if (!context?.presentationCurrent()) return false;
      if (result?.state === 'completed') {
        toast.success('The saved run send is confirmed and recorded on this computer.'); return true;
      }
      if (result?.state === 'refused') toast.warning('This send made no online change. The local plan is available for editing.');
      return false;
    },
  };
}
